export const VACATION_ABSCENCE_TYPES = ["férias", "ferias"];
export const HOLIDAY_ABSCENCE_TYPES = ["feriado"];
export const PROTECTED_ABSCENCE_TYPES = [...VACATION_ABSCENCE_TYPES, ...HOLIDAY_ABSCENCE_TYPES];

const normalizeAbscenceName = (name?: string | null): string => name?.trim().toLowerCase() ?? "";

export const isVacationAbscence = (name?: string | null): boolean =>
    VACATION_ABSCENCE_TYPES.includes(normalizeAbscenceName(name));

export const isProtectedAbscence = (name?: string | null): boolean =>
    PROTECTED_ABSCENCE_TYPES.includes(normalizeAbscenceName(name));
